/**
 * Halloween night backdrop: a glowing moon + a graveyard silhouette (tombstones,
 * a cross, and a bare tree) pinned to the bottom of the viewport, behind content.
 * The night gradient itself is on the theme `body` (CSS); this adds the moon and
 * the silhouette. Static, `pointer-events: none`. Silhouette uses `--silhouette`
 * so it adapts to light/dark.
 */
import React from 'react';

import { Z } from '@shared/constants/zIndex';

/** Fixed moon + graveyard silhouette backdrop. */
export const HalloweenBackdrop: React.FC = () => (
  <div aria-hidden data-testid="halloween-backdrop" className="pointer-events-none fixed inset-0" style={{ zIndex: Z.BACKDROP }}>
    {/* Glowing moon, upper-right. */}
    <div
      className="absolute h-16 w-16 rounded-full"
      style={{
        top: '7%',
        right: '9%',
        background: 'radial-gradient(circle at 38% 35%, oklch(0.96 0.04 80), oklch(0.82 0.09 70))',
        boxShadow: '0 0 44px 14px rgba(255,210,140,0.32)',
      }}
    />
    {/* Graveyard silhouette along the bottom. */}
    <svg
      className="absolute bottom-0 left-0 w-full"
      style={{ height: '26vh', maxHeight: '15rem' }}
      viewBox="0 0 400 90"
      preserveAspectRatio="none"
      fill="var(--silhouette)"
    >
      <path d="M0,90 Q120,70 240,76 T400,72 V90 Z" />
      <path d="M40,82 h18 v-16 a9,9 0 0 0 -18,0 Z" />
      <path d="M92,84 h14 v-12 a7,7 0 0 0 -14,0 Z" />
      <rect x="152" y="60" width="5" height="24" />
      <rect x="147" y="66" width="15" height="5" />
      <path d="M210,82 h16 v-14 a8,8 0 0 0 -16,0 Z" />
      <g stroke="var(--silhouette)" strokeWidth="3.5" fill="none" strokeLinecap="round">
        <path d="M330,82 L332,50 M332,58 L344,48 M332,64 L320,54" />
      </g>
    </svg>
  </div>
);
